<template>
  <div ref="triggerRef" class="popover-trigger" @click="toggle">
    <slot></slot>
  </div>

  <teleport to="body">
    <div v-show="isOpen" ref="popperRef" class="popover-panel">
      <slot name="content"></slot>
    </div>
  </teleport>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch } from "vue";
import { createPopper } from "@popperjs/core";

export default {
  name: "BasePopOver",

  props: {
    modelValue: { type: Boolean, default: false },
    placement: { type: String, default: "bottom" },
    disableTrigger: { type: Boolean, default: false }, // ✅ NEW
    horOffset: { type: Number, default: 50 },
    verOffset: { type: Number, default: 10 },
  },

  emits: ["update:modelValue"],

  setup(props, { emit }) {
    const isOpen = ref(props.modelValue);
    const triggerRef = ref(null);
    const popperRef = ref(null);
    let popperInstance = null;

    // ⛔ Click toggle only when allowed
    const toggle = () => {
      if (!props.disableTrigger) {
        isOpen.value = !isOpen.value;
      }
    };

    // Sync external modelValue → internal state
    watch(
      () => props.modelValue,
      (v) => (isOpen.value = v)
    );

    // Sync internal state → external v-model
    watch(isOpen, (v) => emit("update:modelValue", v));

    function handleClickOutside(e) {
      if (
        triggerRef.value &&
        popperRef.value &&
        !triggerRef.value.contains(e.target) &&
        !popperRef.value.contains(e.target)
      ) {
        isOpen.value = false;
      }
    }

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);

      popperInstance = createPopper(triggerRef.value, popperRef.value, {
        placement: props.placement,
        modifiers: [
          {
            name: "offset",
            options: { offset: [props.horOffset, props.verOffset] },
          },
          { name: "preventOverflow", options: { padding: 8 } },
        ],
      });
    });

    onBeforeUnmount(() => {
      document.removeEventListener("click", handleClickOutside);
      popperInstance?.destroy();
    });

    return {
      isOpen,
      triggerRef,
      popperRef,
      toggle,
    };
  },
};
</script>

<style scoped>
.popover-panel {
  position: absolute;
  z-index: 9999;
  background-color: white;
  color: black;
}
</style>
